import { Collection } from '@/types/documents/documents.types';
import { FiFolder } from 'react-icons/fi';
import {
  CollectionsSectionContainer,
  CollectionsTitle,
  CollectionsGrid,
  CollectionPill,
} from './CollectionsSection.styles';
import { Headers } from '@tw/tw-component-library';

interface CollectionsSectionProps {
  smartCollections: Collection[];
  regularCollections: Collection[];
  activeCollectionFilter: string | null;
  onCollectionClick: (collectionId: string | null) => void;
  isCompact?: boolean;
}

export const CollectionsSection = ({
  smartCollections,
  regularCollections,
  activeCollectionFilter,
  onCollectionClick,
  isCompact = false,
}: CollectionsSectionProps) => {
  if (smartCollections.length === 0 && regularCollections.length === 0) {
    return null;
  }

  const handleCollectionClick = (collectionId: string | null) => {
    if (activeCollectionFilter === collectionId) {
      onCollectionClick(null);
    } else {
      onCollectionClick(collectionId);
    }
  };

  const getCollectionCount = (collection: Collection) => {
    if (collection.count !== undefined) {
      return collection.count;
    }
    if (collection.files) {
      return Object.keys(collection.files).length;
    }
    return 0;
  };

  return (
    <CollectionsSectionContainer $isCompact={isCompact}>
      {/* Smart Collections temporarily disabled - not properly set up */}
      {/* {smartCollections.length > 0 && (
       <>
          <CollectionsTitle>
            <Headers headerType="caption">🤖 AI-SUGGESTED COLLECTIONS</Headers>
          </CollectionsTitle>
          <CollectionsGrid>
            {smartCollections.map((collection: Collection) => {
              const collectionId =
                collection.id || collection.collectionId || null;
              const isActive = activeCollectionFilter === collectionId;
              const count = getCollectionCount(collection);

              return (
                <CollectionPill
                  key={collectionId}
                  active={isActive}
                  isSmart={true}
                  onClick={() => handleCollectionClick(collectionId)}
                >
                  ✨{' '}
                  {collection.name ||
                    collection.title ||
                    'Unnamed Collection'}
                  {count > 0 ? ` (${count})` : ''}
                </CollectionPill>
              );
            })}
          </CollectionsGrid>
        </>
      )} */}
      {regularCollections.length > 0 && (
        <>
          <CollectionsTitle $isCompact={isCompact}>
            <Headers headerType="caption">
              {isCompact ? 'WORKSPACE COLLECTIONS' : '📁 WORKSPACE COLLECTIONS'}
            </Headers>
          </CollectionsTitle>
          <CollectionsGrid $isCompact={isCompact}>
            {regularCollections.map((collection: Collection) => {
              const collectionId =
                collection.id || collection.collectionId || null;
              const isActive = activeCollectionFilter === collectionId;
              const count = getCollectionCount(collection);

              return (
                <CollectionPill
                  key={collectionId}
                  active={isActive}
                  $isCompact={isCompact}
                  onClick={() => handleCollectionClick(collectionId)}
                >
                  {isCompact && <FiFolder />}
                  {collection.name ||
                    collection.title ||
                    'Unnamed Collection'}
                  {count > 0 ? ` (${count})` : ''}
                </CollectionPill>
              );
            })}
          </CollectionsGrid>
        </>
      )}
    </CollectionsSectionContainer>
  );
};


